import React from "react";
import './DetailsEI.css';

class DetailsEI extends React.Component {
    render() {
        return (
            <article className="article br3 ba b--black-10 w-100 w-50-m w-50-l mw7 shadow-5 center">
                <main className="pa4 black-80">
                    <div className="measure">
                        <fieldset id="sign_up" className="ba b--transparent ph0 mh0">
                            <div className='legend center'>
                                <legend className="f1 fw6 ph0 mh0">شرح كامل لكيفية حجز ميعاد الانترفيو و كيفية إلغاء الميعاد</legend>
                            </div>
                            <hr/>

                            <div className="ui form ma0">
                                <div className="fields">
                                    <h3>
                                        ي جماعة اللى بيسألوا على حجز مواعيد السفارة فخلاص مفيش فودافون والكلام دة من يناير اللى فات والوضع اتغير
                                        <br/>
                                        <br/>
                                        لو فيزا شينجن و سياحة او دعوة او اى فيزا مدتها متزيدش عن 90 يوم
                                        <br/>
                                        <a target='_blank' rel='noreferrer' href='https://de.tlscontact.com/eg/cai/index.php'>TLS Contact</a> فبقا الحجز من شركة
                                        <br/>
                                        و لو حد عايز يحجز فيتصل بيهم او يروحلهم ويعرف ايه المطلوب وعنوانهم ورقمهم موجودة على الموقع
                                        <br/>
                                        ........................................
                                        <br/>
                                        اما فيزا الدراسة او لم شمل او بحث عن عمل او عمل او اى فيزا مدتها اكثر من 3 شهور
                                        <br/>
                                        .. فالحجز من موقع السفارة " وببلاش "
                                        <br/>
                                        و مفيش طريقة غير موقع السفارة
                                        <br/>
                                        ........................................
                                        <br/>
                                        طريقة حجز المواعيد فى السفارة الالمانية فى القاهرة
                                        <br/>
                                        <a target='_blank' rel='noreferrer' href='https://kairo.diplo.de/eg-ar/service/05-VisaEinreise/22.2NationaleVisa/22.2.1Termine'>الخبر من موقع السفارة</a>
                                        <br/>
                                        <a target='_blank' rel='noreferrer' href='https://www.facebook.com/groups/311111149267612/permalink/689673301411393/'>الشرح بالتفصيل</a>
                                        <br/>
                                        ........................................
                                        <br/>
                                        و لو حد عايز يلغى ميعاد حجزه 
                                        <br/>
                                        ف ابعتلهم ميل على دة
                                        <br/>
                                        <u>visastelle@kair.auswaertiges-amt.de</u>
                                        <br/>
                                        <br/>
                                        و دى الصيغة 
                                        <br/>
                                        <div className='lft'>
                                            Dear Sir / Madam, 
                                            <br/>
                                            My name is... I have booked an appointment ( in ....2017 from ... to ... am ) and I want to cancel it due to some changes in the date of travel
                                            <br/>
                                            My passport number(..)
                                            <br/>
                                            My phone number (....) 
                                            <br/>
                                            My E-mail (...)
                                            <br/>
                                            Kind regards
                                        </div>
                                        <br/>
                                        <br/>
                                        ويفضل تلغى قبلها ب اسبوع وهيأكدوا عليك بالميل ان الميعاد اتلغى و التأكيد ممكن يجى تانى يوم او يومين او ممكن يطول ل اسبوع بس عموما مش هيطول ل اسبوع 
                                        <br/>
                                        و هيقولوا ليك ان لو لغيت كتير فمن حق السفارة ان هى تعملك بلوك 
                                        <br/>
                                        ف انت لو هتلغى مرة و لما تيجى تحجز تانى مرة ف اختار الميعاد الصح اللى تحجز فيه عشان متضطرش تلغى ويحصلك مشاكل 
                                        <br/>
                                        ........................................
                                        <br/>
                                        دة <a target='_blank' rel='noreferrer' href='https://service2.diplo.de/rktermin/extern/choose_categoryList.do?locationCode=kair&realmId=702'>موقع الحجز</a>
                                        <br/>
                                        لما تفتح الموقع اختار اللغة المانى
                                    </h3>
                                </div>
                            </div>
                        </fieldset>
                    </div>
                </main>
            </article>
        );
    }
}

export default DetailsEI;
